import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/config'
// import { forEach, hasOneOf } from '@/libs/tools'
import Vue from 'vue'
export default new Vue()

// import api from '_conf/url'
export const TOKEN_KEY = 'WSS_token'

export const setToken = token => {
  // Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 })
  Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

// export const setVinToken = (token) => {
//   Cookies.set('vinToken', token)
// }
// export const getVinToken = () => {
//   const token = Cookies.get('vinToken')
//   if (token) return token
//   else return false
// }
// //设置oms2.0token
// export const setOmsTokenCookie = (token) => {
//   Cookies.set('omsToken', token)
// }
// export const getOmsTokenCookie = () => {
//   const token = Cookies.get('omsToken')
//   if (token) return token
//   else return false
// }

// export const getInquiryArr = () => {
//   let inquiryArr = Cookies.get('inquiryArr')
//   if (inquiryArr){
//       let objData = JSON.parse(inquiryArr)
//       return objData
//   }
//   else return false
// }

// //获取当前登陆账号是不是副账号--loginType
// export const getLoginType = () => {
//   let loginData = sessionStorage.loginUserData?JSON.parse(sessionStorage.loginUserData):''
//   if(loginData){
//     return loginData.loginType
//   }
// }

// export const subStringUrl = () =>{
//   let url = api.tokenApi.substring(0, api.tokenApi.indexOf('/jpWeb/'))
//   return url
// }

// export const getInquiryCartSelectData =() =>{
//   let inquiryCartData = ''
//   if(sessionStorage.getItem('car')){
//     //询价单点击立即购买跳转到订单确认页重组数据
//     let ArrData = []
//     let sendData = JSON.parse(sessionStorage.getItem('car'))||[];
//     sendData.map((item,index) => {
//       if(item){
//         if(index===0){
//           ArrData.push(addNewStore(item))
//         }else{
//           let isStore = 0
//           ArrData.map(v=>{
//             if(item.store.id === v.storeId){
//               isStore++
//               v.parts.push(addNewPart(item))
//             }
//           })
//           if(isStore===0){
//             ArrData.push(addNewStore(item))
//           }
//         }
//       }
//     })
//     inquiryCartData = ArrData
//     setInquiryCartSelectData(ArrData)
//     sessionStorage.removeItem('car')
//   }else{
//     inquiryCartData = sessionStorage.getItem('inquiryCartSelectData')?JSON.parse(sessionStorage.getItem('inquiryCartSelectData')):[];
//     inquiryCartData.map(item=>{
//       let parts = [];
//       item.parts.map(v=>{
//         if(v){
//           parts.push(v)
//         }
//       });
//       item.parts=parts;
//     })
//   }
//   return inquiryCartData
// }
// //询价单点击过来重组数据，新加店铺
// export function addNewStore (item) {
//   let objStore = {}
//   objStore.provinceName = item.store.provinceName
//   objStore.areaName= item.store.areaName
//   objStore.cityName= item.store.cityName
//   objStore.doInvoice= ''
//   objStore.leaveMessage= ""
//   objStore.qualitySetting=item.partsQuality
//   objStore.storeCode= item.store.code
//   objStore.storeId=item.store.id
//   objStore.storeName=item.store.cnName

//   objStore.parts = []
//   // let objPart = {}
//   // objPart.classQuality = item.inquiryParent.classQuality
//   // objPart.id = item.id
//   // objPart.inquiryId = item.inquiryId
//   // objPart.inquiryQuotationPartsId=item.id
//   // objPart.num = item.count
//   // objPart.oeCode = item.inquiryParent.oeCode
//   // objPart.remark = item.remark
//   // objPart.partsName= item.inquiryParent.partsName
//   // objPart.partsCode= item.partsCode
//   // objPart.price = item.price
//   // objPart.requirement = item.inquiryParent.partsName
//   // objPart.requirementId = item.inquiryParent.inquiryRequirementId
//   // objPart.totalPirce = item.count*item.price
//   // objPart.venderName= item.venderName
//   // objPart.qualitySetting = item.partsQuality
//   objStore.parts.push(addNewPart(item))
//   return objStore
// }
// //询价单点击过来重组数据，存在相同店铺把商品合并
// export function addNewPart (item) {
//   let objPart = {}
//   objPart.classQuality = item.inquiryParent.classQuality
//   objPart.id = item.id
//   objPart.inquiryId = item.inquiryId
//   objPart.inquiryQuotationPartsId=item.id
//   objPart.num = item.count
//   objPart.oeCode = item.inquiryParent.oeCode
//   objPart.remark = item.remark
//   objPart.partsName= item.inquiryParent.partsName
//   objPart.partsCode= item.partsCode
//   objPart.price = item.price
//   objPart.requirement = item.inquiryParent.partsName
//   objPart.requirementId = item.inquiryParent.inquiryRequirementId
//   objPart.totalPirce = item.count*item.price
//   objPart.venderName= item.venderName
//   objPart.qualitySetting = item.partsQuality
//   objPart.shipWarehouseId = item.shipWarehouseId
//   objPart.platformStoreState=item.store.platformStoreState
//   objPart.erpCompCode=item.store.erpCompCode
//   return objPart
// }

// export const setInquiryCartSelectData =(data) =>{
//   sessionStorage.setItem('inquiryCartSelectData',JSON.stringify(data))
// }

// export const hasChild = (item) => {
//   return item.children && item.children.length !== 0
// }

const showThisMenuEle = (item, access) => {
  if (item.mark && access) {
    // && access.length
    return access.indexOf(item.mark) > -1
  } else return true

  // if (item.meta && item.meta.access && item.meta.access.length) {
  //   if (hasOneOf(item.meta.access, access)) return true
  //   else return false
  // } else return true
}
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
  let res = []
  forEach(list, item => {
    if (item.meta && !item.meta.hideInMenu) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      }
      if (hasChild(item) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}

// /**
//  * @param {Array} routeMetched 当前路由metched
//  * @returns {Array}
//  */
// export const getBreadCrumbList = (routeMetched) => {
//   let res = routeMetched.filter(item => {
//     return item.meta === undefined || !item.meta.hide
//   }).map(item => {
//     let obj = {
//       icon: (item.meta && item.meta.icon) || '',
//       name: item.name,
//       meta: item.meta
//     }
//     return obj
//   })
//   res = res.filter(item => {
//     return !item.meta.hideInMenu
//   })
//   return [{
//     name: 'home',
//     to: '/home'
//   }, ...res]
// }

// export const showTitle = (item, vm) => vm.$config.useI18n ? vm.$t(item.name) : ((item.meta && item.meta.title) || item.name)

// /**
//  * @description 本地存储和获取标签导航列表
//  */
// export const setTagNavListInLocalstorage = list => {
//   localStorage.tagNaveList = JSON.stringify(list)
// }
// /**
//  * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
//  */
// export const getTagNavListFromLocalstorage = () => {
//   const list = localStorage.tagNaveList
//   return list ? JSON.parse(list) : []
// }

// /**
//  * @param {Array} routers 路由列表数组
//  * @description 用于找到路由列表中name为home的对象
//  */
// export const getHomeRoute = routers => {
//   // let i = -1
//   // let len = routers.length
//   // let homeRoute = {}
//   // while (++i < len) {
//   //   let item = routers[i]
//   //   if (item.children && item.children.length) {
//   //     let res = getHomeRoute(item.children)
//   //     if (res.name) return res
//   //   } else {
//   //     if (item.name === 'home') homeRoute = item
//   //   }
//   // }
//   // return homeRoute
// }

// /**
//  * @param {*} list 现有标签导航列表
//  * @param {*} newRoute 新添加的路由原信息对象
//  * @description 如果该newRoute已经存在则不再添加
//  */
// export const getNewTagList = (list, newRoute) => {
//   const { name, path, meta, query} = newRoute
//   let newList = [...list]
//   if (newList.findIndex(item => item.name === name) >= 0) {
//     newList.forEach((v,i) => {
//       if(v.name === name){
//         if(JSON.stringify(v.query)===JSON.stringify(query)){
//           return newList
//         }else{
//           v.query = query
//           //newList.splice(i,1)
//           //newList.push({ name, path, meta,query })
//         }
//       }
//     })
//   }
//   //if (newList.findIndex(item => item.name === name) >= 0) return newList
//   else {
//     newList.push({name, path, meta, query})
//   }
//   return newList

// }

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'business']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access)
    return hasOneOf(access, route.meta.access)
  else return true
}

/**
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  const getHasAccessRouteNames = list => {
    let res = []
    list.forEach(item => {
      if (item.children && item.children.length) {
        res = [].concat(res, getHasAccessRouteNames(item.children))
      } else {
        if (item.mark && access) {
          if (access.indexOf(item.mark) > -1) {
            res.push(item.name)
          }
        } else {
          res.push(item.name)
        }
        // if (item.meta && item.meta.access) {
        //   if (hasAccess(access, item)) res.push(item.name)
        // } else {
        //   res.push(item.name)
        // }
      }
    })
    return res
  }
  const canTurnToNames = getHasAccessRouteNames(routes)
  return canTurnToNames.indexOf(name) > -1
}

// /**
//  * @param {String} url
//  * @description 从URL中解析参数
//  */
// export const getParams = url => {
//   const keyValueArr = url.split('?')[1].split('&')
//   let paramObj = {}
//   keyValueArr.forEach(item => {
//     const keyValue = item.split('=')
//     paramObj[keyValue[0]] = keyValue[1]
//   })
//   return paramObj
// }

// /**
//  * @param {Array} list 标签列表
//  * @param {String} name 当前关闭的标签的name
//  */
// export const getNextName = (list, name) => {
//   let res = ''
//   if (list.length === 2) {
//     res = 'home'
//   } else {
//     if (list.findIndex(item => item.name === name) === list.length - 1) res = list[list.length - 2].name
//     else res = list[list.findIndex(item => item.name === name) + 1].name
//   }
//   return res
// }

// /**
//  * @param {Number} times 回调函数需要执行的次数
//  * @param {Function} callback 回调函数
//  */
// export const doCustomTimes = (times, callback) => {
//   let i = -1
//   while (++i < times) {
//     callback()
//   }
// }

// /**
//  * @param {Object} file 从上传组件得到的文件对象
//  * @returns {Promise} resolve参数是解析后的二维数组
//  * @description 从Csv文件中解析出表格，解析成二维数组
//  */
// export const getArrayFromFile = (file) => {
//   let nameSplit = file.name.split('.')
//   let format = nameSplit[nameSplit.length - 1]
//   return new Promise((resolve, reject) => {
//     let reader = new FileReader()
//     reader.readAsText(file) // 以文本格式读取
//     let arr = []
//     reader.onload = function (evt) {
//       let data = evt.target.result // 读到的数据
//       let pasteData = data.trim()
//       arr = pasteData.split((/[\n\u0085\u2028\u2029]|\r\n?/g)).map(row => {
//         return row.split('\t')
//       }).map(item => {
//         return item[0].split(',')
//       })
//       if (format === 'csv') resolve(arr)
//       else reject(new Error('[Format Error]:你上传的不是Csv文件'))
//     }
//   })
// }

// /**
//  * @param {Array} array 表格数据二维数组
//  * @returns {Object} { columns, tableData }
//  * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
//  */
// export const getTableDataFromArray = (array) => {
//   let columns = []
//   let tableData = []
//   if (array.length > 1) {
//     let titles = array.shift()
//     columns = titles.map(item => {
//       return {
//         title: item,
//         key: item
//       }
//     })
//     tableData = array.map(item => {
//       let res = {}
//       item.forEach((col, i) => {
//         res[titles[i]] = col
//       })
//       return res
//     })
//   }
//   return {
//     columns,
//     tableData
//   }
// }

// export const findNodeUpper = (ele, tag) => {
//   if (ele.parentNode) {
//     if (ele.parentNode.tagName === tag.toUpperCase()) {
//       return ele.parentNode
//     } else {
//       return findNodeUpper(ele.parentNode, tag)
//     }
//   }
// }

// export const findNodeDownward = (ele, tag) => {
//   const tagName = tag.toUpperCase()
//   if (ele.childNodes.length) {
//     let i = -1
//     let len = ele.childNodes.length
//     while (++i < len) {
//       let child = ele.childNodes[i]
//       if (child.tagName === tagName) return child
//       else return findNodeDownward(child, tag)
//     }
//   }
// }

// export const showByAccess = (access, canViewAccess) => {
//   return hasOneOf(canViewAccess, access)
// }

// // 读取文件，避免重复添加
// export function fileReader(files, arr) {
//   [].map.call(files, file => {
//     let bool = arr.find(child => child.file.name === file.name)
//     if (bool) return false
//     arr.push({
//       src: file.name,
//       file: file
//     })
//   })
// }

// // 读取图片，避免重复添加
// export function imageReader(files, arr) {
//   [].map.call(files, file => {
//     let bool = arr.find(child => child.file.name === file.name)
//     if (bool) return false
//     let reader = new FileReader()
//     reader.readAsDataURL(file)
//     reader.onload = function (e) {
//       arr.push({
//         src: this.result,
//         file: file
//       })
//     }
//   })
// }

// // 询价状态转化为 状态信息
// export function inquiryStatus (status) {
//   let result = ''
//   switch (status) {
//     case 1:
//       result = '报价中'
//       break;
//     case 2:
//       result = '报价完成'
//       break;
//     default:
//       result = '已过期'
//       break
//   }
//   return result
// }

// // 转化配件品质
// export function partsQuality (type) {
//   let result = ''
//   switch (type) {
//     case 1:
//       result = '原厂件'
//       break;
//     case 2:
//       result = '品牌件'
//       break;
//     case 3:
//       result = '其他'
//       break;
//     default:
//       result = ''
//       break
//   }
//   return result
// }

// // 订单状态
// export function orderStatus (type) {
//   let result = ''
//   switch (type) {
//     case 1:
//       result = '待付款'
//       break;
//     case 2:
//       result = '待发货'
//       break;
//     case 3:
//       result = '部分发货'
//       break;
//     case 4:
//       result = '全部发货'
//       break;
//     case 5:
//       result = '已完成'
//       break;
//     case 6:
//       result = '已取消'
//       break;
//     case 7:
//       result = '异常'
//       break;
//     case 8:
//       result = '已确认运费'
//       break;
//     default:
//       result = '错误'
//       break
//   }
//   return result
// }

// // 支付方式
// export function shiftPayType (type) {
//   let result = ''
//   switch (type) {
//     case '0':
//       result = '汇款'
//       break;
//     case '1':
//       result = '微信支付'
//       break;
//     case '2':
//       result = '其他'
//       break;
//     default:
//       result = ''
//       break
//   }
//   return result
// }

// // 日期格式化函数
// Date.prototype.format = function (formatStr) {
//   var str = formatStr;
//   var Week = ['日', '一', '二', '三', '四', '五', '六'];
//   str = str.replace(/yyyy|YYYY/, this.getFullYear());
//   str = str.replace(/yy|YY/, (this.getYear() % 100) > 9 ? (this.getYear() % 100).toString() : '0' + (this.getYear() % 100));

//   var month = this.getMonth() + 1;
//   str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
//   str = str.replace(/M/g, month);

//   str = str.replace(/w|W/g, Week[this.getDay()]);

//   str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
//   str = str.replace(/d|D/g, this.getDate());

//   str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
//   str = str.replace(/h|H/g, this.getHours());
//   str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
//   str = str.replace(/m/g, this.getMinutes());

//   str = str.replace(/ss|SS/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
//   str = str.replace(/s|S/g, this.getSeconds());
//   return str;
// }
// export const handleFile = (data) =>{
//   const  link =document.createElement('a')
//   link.style.display = 'none'
//   link.href =URL.createObjectURL(data)
//   link.setAttribute('download',`订单数据.xlsx`)
//   document.body.appendChild(link)
//   link.click()
//       document.body.removeChild(link)
//       window.URL.revokeObjectURL(link.href)
// }


/**
 * 处理文档流下载
 * @param {new Blob} data 文档流
 * @param { String } title 文件名
 */
export const handleFile = (data,title) => {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = URL.createObjectURL(data)
  link.setAttribute('download',`${title}.xlsx`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(link.href)
}